import { Box, Button, Typography, styled } from "@mui/material";

import AlertModal from "components/AlertModal";
import NumberFormats from "components/NumberFormats";
import { SpaceBetweenBox } from "components/GeneralStyled";

function ConfirmAcceptModal({ open, onClose, tradeInsertInitial }) {
  return (
    <AlertModal
      open={open}
      onClose={onClose}
      variant={tradeInsertInitial?.succeeded ? "success" : "error"}
    >
      <Box>
        {tradeInsertInitial?.succeeded ? (
          <>
            <BoxSide>
              <Typography variant="h4" fontWeight={700}>
                {tradeInsertInitial?.succeeded ? "Success" : "Error"}
              </Typography>
            </BoxSide>
            <Typography
              display="flex"
              justifyContent="center"
              paddingBottom={1}
              variant="subtitle1"
              component="small"
              color={
                tradeInsertInitial?.data?.side === "Buy"
                  ? "success.main"
                  : "error.main"
              }
            >
              {tradeInsertInitial?.data?.side} {tradeInsertInitial?.data?.type}
            </Typography>

            <SpaceBetweenBox>
              <Typography color="text.secondary" variant="h6">
                Amount
              </Typography>

              <Typography textAlign="end">
                <Typography component="b" color="text.main" variant="h5">
                  <NumberFormats value={tradeInsertInitial?.data?.filled} />
                </Typography>{" "}
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="small"
                >
                  {" "}
                  {tradeInsertInitial?.data?.coinSourceName}
                </Typography>
              </Typography>
            </SpaceBetweenBox>

            <SpaceBetweenBox>
              <Typography color="text.secondary" variant="h6">
                Fee
              </Typography>

              <Typography textAlign="end">
                <Typography component="b" variant="h5" color="text.main">
                  <NumberFormats value={tradeInsertInitial?.data?.fee} />{" "}
                </Typography>{" "}
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="small"
                >
                  {" "}
                  {tradeInsertInitial?.data?.coinFeeName}
                </Typography>
              </Typography>
            </SpaceBetweenBox>

            <SpaceBetweenBox>
              <Typography color="text.secondary" variant="h6">
                Total
              </Typography>

              <Typography textAlign="end">
                <Typography component="b" variant="h5" color="text.main">
                  <NumberFormats value={tradeInsertInitial?.data?.total} />{" "}
                </Typography>

                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="small"
                >
                  {" "}
                  {tradeInsertInitial?.data?.coinDestinationName}
                </Typography>
              </Typography>
            </SpaceBetweenBox>
          </>
        ) : (
          <Typography>ERROR</Typography>
        )}
      </Box>
      <Box marginTop={2}>
        <Button fullWidth onClick={onClose} color="success">
          بازگشت
        </Button>
      </Box>
    </AlertModal>
  );
}

const BoxSide = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  paddingTop: theme.spacing(4),
}));
export default ConfirmAcceptModal;
